<template>
  <div>
    <!-- {{checkDeletePermission}}
  {{checkEditPermission}} -->

    <ag-grid-vue
      ref="agGridTable"
      :defaultColDef="defaultColDef"
      :gridOptions="gridOptions"
      :context="context"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
      :animateRows="true"
      :floatingFilter="false"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      :columnDefs="columnDefs"
      :rowData="roomList"
      @grid-ready="onGridReady"
      @sortChanged="sortFun"
    />
    <!-- <vs-table
      class="assets-table"
      :data="roomList"
    >
      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th>Name</vs-th>
        <vs-th>No. of Persons</vs-th>
        <vs-th>Suitable For</vs-th>
        <vs-th>Price</vs-th>
        <vs-th v-if="checkDeletePermission || checkEditPermission">Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            {{data}}
          <vs-td>
              <img
              v-if="data[indextr].defaultImage.length"
              class="room-img"
              :src="data[indextr].defaultImage[0].files_details.file_path"
            />
            <img
            v-else
              class="room-img"
              src="https://maestroselectronics.com/wp-content/uploads/2017/12/No_Image_Available.jpg"
            />
          </vs-td>
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>
          <vs-td :data="data[indextr].number_of_person">
            {{ data[indextr].number_of_person }}
          </vs-td>
          <vs-td>
            <div
              v-for="(eachsuitable, index) in data[indextr].asset_tags"
              :key="index"
            >
              {{ eachsuitable.tag_name }}
              <span v-if="index + 1 < data[indextr].asset_tags.length"
                >,</span
              >
            </div>
          </vs-td>

          <vs-td>
            <div class="flex">
              <p class="mr-1">&#163;  {{ data[indextr].price }}</p>
            </div>
          </vs-td>
          <vs-td v-if="checkDeletePermission || checkEditPermission">
            <div class="flex">
              <vs-button
              v-if="checkEditPermission"
                @click="editInventory(data[indextr])"
                class="mx-1"
                icon-pack="feather"
                icon="icon-edit"
              ></vs-button>
              <vs-button
              v-if="checkDeletePermission"
                class="mx-1"
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                @click="deleteInventory(data[indextr].assets_id, indextr)"
              ></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table> -->
  </div>
</template>

<script>
import { deleteRoomApi } from '@/api/room'
import { AgGridVue } from 'ag-grid-vue'
import ActionCellRenderer from '../ActionCellRenderer.vue'

export default {
  data () {
    return {
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      meta: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      context: {},
      gridApi: null,
      gridOptions: {
        accentedSort: true
      }
    }
  },
  props: {
    roomList: {
      type: Array,
      required: true,
      default: () => []
    },
    checkEditPermission: {},
    checkDeletePermission: {}
  },
  components: {
    AgGridVue,
    ActionCellRenderer
  },
  mounted () {
    // this.gridApi = this.gridOptions.api
  },
  beforeMount () {
    this.context = {
      componentParent: this
    }

    this.columnDefs = [
      // {
      //   headerName: '',
      //   minWidth: 60,
      //   field: 'isSelected',
      //   filter: false,
      //   checkboxSelection: (params) => {
      //     return true
      //   },
      //   headerCheckboxSelectionFilteredOnly: true,
      //   headerCheckboxSelection: true
      // },
      {
        headerName: 'Image',
        field: '',
        sortable: false,
        filter: false,
        width: 100,
        editable: false,
        cellRenderer: params => {
          let template = ''
          let image =
            'https://maestroselectronics.com/wp-content/uploads/2017/12/No_Image_Available.jpg'
          if (params.data.asset_images.length) {
            image = params.data.asset_images[0].files_details.file_path
          }
          // console.log(params.data.asset_images[0].files_details.file_path)
          template = `<img src="${image}" alt="No Image" style="width: 40px;height: 40px;margin-top: 3px;border-radius: 10px;"/>`
          return template
        }
      },
      {
        headerName: 'Name',
        field: 'name',
        filter: false,
        minWidth: 150,
        editable: false
      },
      {
        headerName: 'No. of Persons',
        field: 'number_of_person',
        filter: false,
        minWidth: 150,
        editable: false
      },
      {
        headerName: 'Suitable For',
        field: 'tags',
        filter: false,
        minWidth: 150,
        editable: false,
        valueGetter: (params)=>{
         
          return params.data.suitable_for

        }
      },
      {
        headerName: 'Price',
        field: 'price',
        filter: false,
        minWidth: 150,
        editable: false,
        cellRenderer: params => {
          let template = ''
          template = `<p> £ ${params.data.price}</p>`
          return template
        }
      },
      {
        headerName: 'Action',
        field: '',
        filter: false,
        minWidth: 100,
        maxWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: 'ActionCellRenderer',
        filterParams: {}
      }
    ]
  },
  methods: {
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = sortState[0].colId

          this.sorting_obj.direction = sortState[0].sort

          this.$emit('sortFunc', this.sorting_obj)
        }
      } catch (e) {
      } finally {
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    editInventory (eachList) {
      this.$emit('editList', eachList)
    },

    async deleteInventory (assetsId, index) {
      const assets_id = [assetsId]
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          asset_types: 'Room',
          assets_id
        }

        const data = await deleteRoomApi(payload)

        this.showSuccessMessage(
          'Success',
          'Room Deleted Successfully',
          'success'
        )
        console.log(this.roomList, index)
        this.roomList.splice(index, 1)
        this.$emit('deleteInventory', index)
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped></style>
